import API from '../api'
import { 
    ORDER_CREATE_FAIL,
    ORDER_CREATE_REQUEST,
    ORDER_CREATE_SUCCESS,  
    ORDER_LIST_REQUEST, 
    ORDER_LIST_SUCCESS,
    ORDER_LIST_FAIL,
    TOGGLE_CREATE_ORDER_MODAL,
    ORDER_DELETE_REQUEST,
    ORDER_DELETE_SUCCESS,
    ORDER_DELETE_FAIL,
    ORDER_MARK_AS_READ_REQUEST,
    ORDER_MARK_AS_READ_SUCCESS,
    ORDER_MARK_AS_READ_FAIL,
    ORDER_DETAIL_MODAL_TOGGLE,
    ORDER_DETAILS_REQUEST,
    ORDER_DETAILS_SUCCESS,
    ORDER_DETAILS_FAIL,
} from "../constants/orderConstants";
import { clearCart } from "./cartActions";

export const toggleCreateOrderModal = () => (dispatch, getState) => {
    dispatch({
        type: TOGGLE_CREATE_ORDER_MODAL,
        payload: {
            items: getState().cart.cartItems,
        }
    })
}

export const listOrders = (query = {}) => async (dispatch) => {
    try {
        dispatch({ type: ORDER_LIST_REQUEST });

        const { page, limit } = query;
        const queryStringNotNulls = Object.entries({
            page,
            limit
        }).filter(([, value]) => value !== undefined).map(([key, value]) => `${key}=${value}`).join('&')

        const { data }  = await API.get(`/orders${queryStringNotNulls ? `?${queryStringNotNulls}` : ''}`) 

        if(!data.ok || !data.orders){
            throw new Error("Something went wrong");
        }

        dispatch({
            type: ORDER_LIST_SUCCESS,
            payload: data.orders,
        });
    } catch (error) {
        dispatch({
            type: ORDER_LIST_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
}  

export const createOrder = (payload) => async (dispatch) => {
    const { order, onSuccess, onError } = payload;
    try {
        dispatch({ type: ORDER_CREATE_REQUEST });

        const { data } = await API.post("/orders/place", {
            customerName: order.name,
            customerPhone: order.phone,
            customerEmail: order.email,
            items: order.items
        },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        console.log(data);

        // Simulate API request
        setTimeout(() => {
            dispatch({
                type: ORDER_CREATE_SUCCESS,
                payload: order,
            });
            dispatch(clearCart());
            onSuccess();
        }, 1000);
    } catch (error) {
        dispatch({
            type: ORDER_CREATE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
        onError();
    }
}

export const markOrderAsRead = (orderId) => async (dispatch) => {
    try {
        dispatch({ type: ORDER_MARK_AS_READ_REQUEST });

        const { data } = await API.put(`/orders/read/${orderId}`);

        if(!data.ok){
            throw new Error("Something went wrong");
        }

        dispatch({
            type: ORDER_MARK_AS_READ_SUCCESS,
            payload: data.orders,
        });
    } catch (error) {
        dispatch({
            type: ORDER_MARK_AS_READ_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
}

export const archiveOrder = (orderId) => async (dispatch) => {
    try {
        dispatch({ type: ORDER_DELETE_REQUEST });

        const { data } = await API.delete(`/orders/${orderId}`);

        if(!data.ok){
            throw new Error("Something went wrong");
        }

        dispatch({
            type: ORDER_DELETE_SUCCESS,
            payload: data.orders,
        });
    } catch (error) {
        dispatch({
            type: ORDER_DELETE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
}

export const toggleOrderDetailModal = (order) => (dispatch) => {
    dispatch({
        type: ORDER_DETAIL_MODAL_TOGGLE,
        payload: order,
    });
}

export const getOrderDetail = (orderId) => async (dispatch) => {
    try {
        dispatch({ type: ORDER_DETAILS_REQUEST });

        const { data } = await API.get(`/orders/${orderId}`);

        if(!data.ok){
            throw new Error("Something went wrong");
        }

        const items = data?.orderDetail?.items ?? [];

        dispatch({
            type: ORDER_DETAILS_SUCCESS,
            payload: items,
        });
    } catch (error) {
        dispatch({
            type: ORDER_DETAILS_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        });
    }
}

export const clearOrderDetail = () => (dispatch) => {
    dispatch({
        type: ORDER_DETAILS_SUCCESS,
        payload: null,
    });
}

export const clearOrders = () => (dispatch) => {
    dispatch({
        type: ORDER_LIST_SUCCESS,
        payload: [],
    });
}